var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentOk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    width: 24,
    height: 24,
    rx: 2,
    fill: "#0E4195"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72411 14.7793C9.64271 14.8697 9.5009 14.8697 9.4195 14.7793L7.13206 12.238C6.72658 11.7876 6.02019 11.7876 5.61471 12.238C5.26526 12.6263 5.26526 13.2157 5.61471 13.6039L9.30608 17.7048C9.4481 17.8626 9.69551 17.8626 9.83753 17.7048L18.3853 8.20867C18.7347 7.82045 18.7347 7.23107 18.3853 6.84285C17.9798 6.39238 17.2734 6.39238 16.8679 6.84285L9.72411 14.7793Z",
    fill: "#0E4195"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentOk);
export default __webpack_public_path__ + "static/media/comment-ok.97bb41606604e096e3b0504f00302de6.svg";
export { ForwardRef as ReactComponent };